import { render, staticRenderFns } from "./MultiStoreBoard.vue?vue&type=template&id=5f611ccd&scoped=true"
import script from "./MultiStoreBoard.vue?vue&type=script&lang=js"
export * from "./MultiStoreBoard.vue?vue&type=script&lang=js"
import style0 from "./MultiStoreBoard.vue?vue&type=style&index=0&id=5f611ccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f611ccd",
  null
  
)

export default component.exports